import React from 'react';
import { Video } from './Common/Video';
import { Image } from './Common/Image';

const VideoInsidePhone = ({ blockVideo }) => {
    return (
        <div className="video-frame">
            <Image image={blockVideo.videoFrame} cla="frame-iphone"></Image>
            <div className="video-wrap">
                <div className="outer">
                    <Video video={blockVideo.video}></Video>
                </div>
            </div>
        </div>
    )
}

const ContentfulBlockVideo = (blockVideo) => {
    var content = '';
    switch (blockVideo.layout) {
        case 'Video Inside Phone':
            content = <VideoInsidePhone blockVideo={blockVideo}></VideoInsidePhone>
            break;

        default:
            content = <></>
            break;
    }
    return (<>{content}</>)
}

export { ContentfulBlockVideo}
